import axios from 'axios'
import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { gettoken } from '../Localstorage/Store'
import {  useSelector } from "react-redux";

const Footer = () => {
  const { bgColor, textColor } = useSelector((state) => state.theam);

const [email,setemail] = useState('')
const [fname,setfname] = useState('')
const tokenvalue = gettoken();

const [isHovered1, setIsHovered1] = useState(false);
const [isHovered2, setIsHovered2] = useState(false);
const [isHovered3, setIsHovered3] = useState(false);
const [isHovered4, setIsHovered4] = useState(false);
const [isHovered5, setIsHovered5] = useState(false);
const [isHovered6, setIsHovered6] = useState(false);

const [newsletterresponse,setnewsletterresponse] = useState('')
  const newsletter = async (e) =>{
    e.preventDefault();
    try {
      const postData = {
        full_name:fname,
        email:email
      }
      // Make a POST request using axios
      const response = await axios.post(`${process.env.REACT_APP_API_URL}MyNewsLetterApi/subscriber/`, postData);
      console.log('Response:', response.data.message);
      setnewsletterresponse(response.data.message);
      setfname('')
      setemail('')
      setTimeout(() => {
        setnewsletterresponse('')
      }, 3000);

    } catch (error) {
      // Handle errors here
      console.error('Error:', error.message);
    }
  }
  return (
<footer>
  <div className="footer1 pb-1">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="footer-main">
            <div className="footer-box">
         
              <div className="footer-contant">
                <div className="">
                  <NavLink href="/Home">
                    <img   src={`${process.env.REACT_APP_API_PUBLIC_URL}/images/newlogo/newlogooneup.png`} className="maxwidthlogo22" alt="logo" />

                  
                  </NavLink>
                </div>
                
              </div>
            </div>
           
            <div className="footer-box">
       
              <div className="footer-contant">
                <ul className='newgap' style={{display:'flex'}}>
                  <li style={{display:'flex',alignItems:'center',paddingBottom:'0px',            color: isHovered1 ? `#${textColor}` : "black",}}  
                  onMouseEnter={() => setIsHovered1(true)}
                onMouseLeave={() => setIsHovered1(false)}>
                  <NavLink className='' to="/contact" style={{ color: isHovered1 ? `#${textColor}` : "black",}}>Contact Us</NavLink></li>

                  {tokenvalue ? '' : <li style={{display:'flex',alignItems:'center',paddingBottom:'0px'}}       onMouseEnter={() => setIsHovered2(true)}
                onMouseLeave={() => setIsHovered2(false)}><NavLink  to="/track-order" style={{ color: isHovered2 ? `#${textColor}` : "black",}}>Track Order</NavLink></li> }


                  {!tokenvalue ? '' : tokenvalue.msg == "Voucher login" ? "":  <li className='hideonphone' style={{display:'flex',alignItems:'center',paddingBottom:'0px'}}
                  onMouseEnter={() => setIsHovered3(true)}
                  onMouseLeave={() => setIsHovered3(false)}
                  ><NavLink className='' to="/mycredit" style={{ color: isHovered3 ? `#${textColor}` : "black",}}>My Credit</NavLink></li> }

                  {!tokenvalue ? '' : tokenvalue.msg == "Voucher login" ? "":  
                  <li className='hideonphone' style={{display:'flex',alignItems:'center',paddingBottom:'0px'}}
                    onMouseEnter={() => setIsHovered4(true)}
                    onMouseLeave={() => setIsHovered4(false)}
                    ><NavLink className='bluehover' to="/voucher-request" style={{ color: isHovered4 ? `#${textColor}` : "black",}}
                    >Voucher Request</NavLink></li> }

                  <li style={{display:'flex',alignItems:'center',paddingBottom:'0px'}}
                  onMouseEnter={() => setIsHovered5(true)}
                  onMouseLeave={() => setIsHovered5(false)}
                  ><NavLink className='' to="/privacypolicy"
                  style={{ color: isHovered5 ? `#${textColor}` : "black",}}
                  >Privacy Policy</NavLink></li>

                  <li style={{display:'flex',alignItems:'center',paddingBottom:'0px'}}
                   onMouseEnter={() => setIsHovered6(true)}
                   onMouseLeave={() => setIsHovered6(false)}><NavLink className='' to="/termsconditions"
                   style={{ color: isHovered6 ? `#${textColor}` : "black",}}>
Terms of use</NavLink></li>
                  <li>
                  <i className="fa fa-envelope-o" /> <span style={{textTransform: "lowercase"}}>
                    support@oneupshop.in
                    </span>
                  </li>
                
                </ul>
              </div>
            </div>
         
            
          </div>
          <div style={{textAlign:'center',paddingBottom:'13px',paddingTop:'14px',color:'#919297'}}><ul className="paymant" style={{display:'flex',justifyContent:'center',gap:'9px'}}>
                  <li>
                    <a href="javascript:void(0)"><img src={`${process.env.REACT_APP_API_PUBLIC_URL}/images/layout-1/pay/1.png`} className="img-fluid" alt="pay" /></a>
                  </li>
                  <li>
                    <a href="javascript:void(0)"><img src={`${process.env.REACT_APP_API_PUBLIC_URL}/images/layout-1/pay/2.png`} className="img-fluid" alt="pay" /></a>
                  </li>
                  <li>
                    <a href="javascript:void(0)"><img src={`${process.env.REACT_APP_API_PUBLIC_URL}/images/layout-1/pay/3.png`} className="img-fluid" alt="pay" /></a>
                  </li>
                  <li>
                    <a href="javascript:void(0)"><img src={`${process.env.REACT_APP_API_PUBLIC_URL}/images/layout-1/pay/4.png`} className="img-fluid" alt="pay" /></a>
                  </li>
                  <li>
                    <a href="javascript:void(0)"><img src={`${process.env.REACT_APP_API_PUBLIC_URL}/images/layout-1/pay/5.png`} className="img-fluid" alt="pay" /></a>
                  </li>
                </ul></div>
          <div style={{textAlign:'center',paddingBottom:'13px',paddingTop:'14px',color:'#919297'}}><h6 >©2024 OneUpShop. All rights reserved</h6></div>
        </div>
      </div>
    </div>
  </div>
</footer>


  )
}

export default Footer